import { stringify } from "qs";
import fetchClient from "api/client";
import getPerPageQueryParam from "helpers/getPerPageQueryParam";

/**
 * @description GET api/campaigns/list
 * */
export default function getPhasesFilterList({
  queryKey: [, { page, perPage, ...queryParams }],
  signal,
}) {
  const queryString = stringify(
    {
      ...queryParams,
      page: page || 0,
      ...getPerPageQueryParam(perPage),
    },
    { addQueryPrefix: true },
  );

  return fetchClient.get(`campaigns/list${queryString}`, { signal });
}
